/**
 * 日程管理服务 - 日程相关 API
 * 路径与后端 /project/schedules 对齐
 */

import api from '../../api';
import type { Result, PageResult } from '../../types';
import type { Schedule } from '../../../types';

export const getSchedules = (params: Record<string, unknown>): Promise<Result<PageResult<Schedule>>> => {
  return api.get('/project/schedules', { params });
};

export const getScheduleById = (id: string): Promise<Result<Schedule>> => {
  return api.get(`/project/schedules/${id}`);
};

export const createSchedule = (data: Record<string, unknown>): Promise<Result<string>> => {
  return api.post('/project/schedules', data);
};

export const updateSchedule = (id: string, data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put(`/project/schedules/${id}`, data);
};

export const deleteSchedule = (id: string): Promise<Result<void>> => {
  return api.delete(`/project/schedules/${id}`);
};

export const batchDeleteSchedules = (ids: string[]): Promise<Result<void>> => {
  return api.delete('/project/schedules/batch', { data: ids });
};

export const getTodaySchedules = (userId?: string): Promise<Result<Schedule[]>> => {
  return api.get('/project/schedules/today', { params: userId ? { userId } : {} });
};

export const getWeekSchedules = (userId?: string): Promise<Result<Schedule[]>> => {
  return api.get('/project/schedules/week', { params: userId ? { userId } : {} });
};

export const getMonthSchedules = (userId?: string): Promise<Result<Schedule[]>> => {
  return api.get('/project/schedules/month', { params: userId ? { userId } : {} });
};

export const getSchedulesByDateRange = (start: string, end: string, userId?: string): Promise<Result<Schedule[]>> => {
  return api.get('/project/schedules/range', { params: { start, end, ...(userId ? { userId } : {}) } });
};

export const countScheduleByType = (userId?: string): Promise<Result<Record<string, number>>> => {
  return api.get('/project/schedules/statistics/type', { params: userId ? { userId } : {} });
};

export const countScheduleByStatus = (userId?: string): Promise<Result<Record<string, number>>> => {
  return api.get('/project/schedules/statistics/status', { params: userId ? { userId } : {} });
};

export const getPendingReminds = (): Promise<Result<Schedule[]>> => {
  return api.get('/project/schedules/reminds');
};

export const checkTimeConflict = (
  userId: string,
  startTime: string,
  endTime: string,
  excludeScheduleId?: string
): Promise<Result<{ hasConflict: boolean }>> => {
  return api.post('/project/schedules/check-conflict', null, {
    params: { userId, startTime, endTime, ...(excludeScheduleId ? { excludeScheduleId } : {}) }
  });
};

export const completeSchedule = (id: string): Promise<Result<void>> => {
  return api.post(`/project/schedules/${id}/complete`);
};

export const cancelSchedule = (id: string): Promise<Result<void>> => {
  return api.post(`/project/schedules/${id}/cancel`);
};

export const startSchedule = (id: string): Promise<Result<void>> => {
  return api.post(`/project/schedules/${id}/start`);
};

export const markScheduleNotExecuted = (id: string, reason: string): Promise<Result<void>> => {
  return api.post(`/project/schedules/${id}/not-executed`, null, { params: { reason } });
};

export const getScheduleTypeMapping = (): Promise<Result<Record<string, string>>> => {
  return api.get('/project/schedules/type-mapping');
};
